module.exports = __webpack_public_path__ + "static/media/minimize.ed42665b.svg";